import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M12.8156 1.63104C12.5344 1.34978 12.0785 1.34978 11.7973 1.63104L10.8076 2.62074L13.3792 5.19241L14.3689 4.2027C14.6502 3.92145 14.6502 3.46563 14.369 3.18437L12.8156 1.63104ZM12.3751 6.19656L9.80341 3.6249L2.58316 10.8451L5.15483 13.4168L12.3751 6.19656ZM3.67713 13.9474L2.05256 12.3228L1.72763 14.2723L3.67713 13.9474ZM10.7931 0.626876C11.629 -0.208959 12.9839 -0.208959 13.8198 0.626876L15.3731 2.18021C16.2089 3.01605 16.2089 4.37102 15.3731 5.20686L5.49601 15.0839L0 16L0.916024 10.5039L10.7931 0.626876Z" />,
  'Pencil',
);
